<template>
    <div class='item-uploadVideo'>
<!--        <div class='deletes' v-if='imageUrl' @click="deleteUrl">-->
<!--            <i class="el-icon-error"></i>-->
<!--        </div>-->
        <div class='uploadVideo'>
            <el-input size="small" style="padding-right: 10px" v-model="videoUrl" readonly placeholder="视频链接"></el-input>
            <el-button size="small" @click="handleUploadClick" :loading="uploading">上传</el-button>
            <el-button size="small" @click="handlePreview" :disabled="!videoUrl">预览</el-button>
        </div>
        <!-- 隐藏的文件输入，用于选择视频文件 -->
        <input
            ref="fileInput"
            type="file"
            accept="video/*"
            class="hidden-file-input"
            @change="handleFileChange"
        />
        
        <!-- 视频预览弹窗 -->
        <el-dialog
            title="视频预览"
            :visible.sync="previewVisible"
            width="800px"
            :before-close="handleClosePreview"
        >
            <div class="video-preview-container">
                <video
                    v-if="videoUrl"
                    :src="videoUrl"
                    controls
                    style="width: 100%; max-height: 500px;"
                    @error="handleVideoError"
                >
                    您的浏览器不支持视频播放
                </video>
                <div v-else class="no-video">
                    <i class="el-icon-warning"></i>
                    <p>暂无视频</p>
                </div>
            </div>
        </el-dialog>
    </div>



</template>

<script>
import { upload } from '@/utils/request';
import { UPLOAD_PATH } from '@/utils/constant';

export default {
    props:{
        imageUrl:{
            type:String,
            default:''
        }
    },
    data() {
        return {
            videoUrl: '',
            uploading: false,
            previewVisible: false
        }
    },
    watch: {
        imageUrl: {
            immediate: true,
            handler(newVal) {
                this.videoUrl = newVal || '';
            }
        }
    },
    methods: {
        // 点击上传按钮
        handleUploadClick() {
            this.$refs.fileInput.click();
        },
        
        // 文件选择变化
        handleFileChange(event) {
            const file = event.target.files[0];
            if (!file) {
                return;
            }
            
            // 校验文件类型
            const videoTypes = ['video/mp4', 'video/avi', 'video/mov', 'video/wmv', 'video/flv', 'video/webm'];
            const fileExtension = file.name.split('.').pop().toLowerCase();
            const allowedExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm'];
            
            const isVideoType = videoTypes.includes(file.type) || allowedExtensions.includes(fileExtension);
            
            if (!isVideoType) {
                this.$message.error('请上传视频文件格式（mp4/avi/mov/wmv/flv/webm）!');
                event.target.value = ''; // 清空选择
                return;
            }
            
            // 校验文件大小（限制为500MB）
            const isLt500M = file.size / 1024 / 1024 < 500;
            if (!isLt500M) {
                this.$message.error('视频文件大小不能超过 500MB!');
                event.target.value = ''; // 清空选择
                return;
            }
            
            // 上传视频
            this.uploadVideo(file);
        },
        
        // 上传视频
        uploadVideo(file) {
            this.uploading = true;
            
            const formData = new FormData();
            formData.append('file', file);
            
            upload('/mpp/file/upload', formData).then((res) => {
                this.uploading = false;
                if (res.success) {
                    this.$message({
                        message: '视频上传成功',
                        type: 'success',
                        duration: 2000
                    });
                    // 更新input显示
                    this.videoUrl = res.url;
                    // 触发更新事件，传递视频URL
                    this.$emit('updateUrl', res.url);
                } else {
                    this.$message.error(res.msg || '视频上传失败');
                }
                // 清空文件选择
                this.$refs.fileInput.value = '';
            }).catch((error) => {
                this.uploading = false;
                this.$message.error('视频上传失败，请重试');
                console.error('上传视频失败:', error);
                // 清空文件选择
                this.$refs.fileInput.value = '';
            });
        },
        
        deleteUrl(){
            this.videoUrl = '';
            this.$emit('deleteUrl');
        },
        
        // 预览视频
        handlePreview() {
            if (!this.videoUrl) {
                this.$message.warning('请先上传视频');
                return;
            }
            this.previewVisible = true;
        },
        
        // 关闭预览弹窗
        handleClosePreview() {
            this.previewVisible = false;
        },
        
        // 视频加载错误
        handleVideoError(event) {
            this.$message.error('视频加载失败，请检查视频链接是否正确');
            console.error('视频加载错误:', event);
        },
    }
};
</script>

<style lang='scss' scoped>

.item-uploadVideo{
    position: relative;
    padding: 10px 0;
    .deletes{
        position: absolute;
        top: -5px;
        left: 55px;
        width: 15px;
        height: 15px;
        z-index: 1;
        font-size: 24px;
    }
}

.uploadVideo {
    //background-color: #eee;
    display: flex;
    flex-direction: row;
    //gap: 10px;
    align-items: center;
}

.hidden-file-input {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    overflow: hidden;
    pointer-events: none;
    left: -9999px;
    top: -9999px;
}

.video-preview-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
    
    .no-video {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #909399;
        padding: 40px;
        
        i {
            font-size: 48px;
            margin-bottom: 16px;
        }
        
        p {
            font-size: 14px;
            margin: 0;
        }
    }
}
</style>